/** Join 页样式配置（字号、卡片尺寸在此调节，单位 px） */
export const JoinConfig = {
  /** 「第一次使用麻雀系统? 你可以:」标题字号 */
  headingFontSizePx: 24,
  /** 卡片主标题字号（如「加入一个已有的团队/企业」） */
  cardTitleFontSizePx: 16,
  /** 卡片副标题字号 */
  cardSubtitleFontSizePx: 12,
  /** 卡片宽度 */
  cardWidthPx: 375,
  /** 卡片高度 */
  cardHeightPx: 75,
} as const
